module.exports = __webpack_public_path__ + "static/media/1.a5781826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9021/1.jpg
// module id = 869
// module chunks = 0